jQuery(document).ready(function($){
    $( '.sg-embed_link' ).on( 'click', function() {
        var link = $( this ).data( 'link' );
        $( '#embedModal iframe' ).attr( 'src', link );
    });
    $("#embedModal").on("hidden.bs.modal", function () {
        $( '#embedModal iframe' ).attr( 'src', '' );
    });
});